import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { Role } from './role.interface';
import { ApiResource } from './../../../models/api-resource.interface';

export interface RoleServiceInterface {
   getRoles(moduleId: number, query: LocationQuery): Promise<ApiResource<Role>>;
}

export class RoleService implements RoleServiceInterface {
   async getRoles(moduleId: number, query: LocationQuery): Promise<ApiResource<Role>> {
      return http.get<ApiResource<Role>>(`/modules/${moduleId}/roles`, { params: { ...query } }).then((response) => response.data);
   }
}
